module.exports = __webpack_public_path__ + "fonts/SFUIText-BoldItalic.3bd63bf4.eot";